<template>
<div class="chapter">
<div class="inner_page">
<div class="phase1" id="phase1">
<div class="chapterHead">
<h2 class="chapterTitle">PHASE ONE</h2>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// WingedVictory_phase1.vue?270207e6